import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  UpdateAllUserNotifications as UpdateAllUserNotificationsResponseGenerated,
  UpdateAllUserNotificationsVariables as UpdateAllUserNotificationsVariablesGenerated,
} from "core/queries/__generated__/UpdateAllUserNotifications";

export interface UpdateAllUserNotificationsResponse
  extends UpdateAllUserNotificationsResponseGenerated {}
export interface UpdateAllUserNotificationVariables
  extends UpdateAllUserNotificationsVariablesGenerated {}

export const updateUserNotification = gql`
  mutation UpdateAllUserNotifications($archive: Boolean!) {
    updateUserNotifications(archive: $archive) {
      success
    }
  }
`;

interface UseUpdateAllUserNotificationsQueryOptions {
  awaitRefetchQueries?: boolean;
  onCompleted?: (data: UpdateAllUserNotificationsResponse) => void;
  refetchQueries?: string[];
}

export const useUpdateAllUserNotifications = ({
  awaitRefetchQueries,
  onCompleted,
  refetchQueries = [],
}: UseUpdateAllUserNotificationsQueryOptions) =>
  useMutation<
    UpdateAllUserNotificationsResponse,
    UpdateAllUserNotificationVariables
  >(updateUserNotification, {
    awaitRefetchQueries,
    onCompleted,
    refetchQueries,
  });
